import { SVGProps } from 'react';

import { Theme } from '@mui/material';

import SlackColorToneIcon from '~icons/knowz-iconify/slack-color-tone';
import AppleDarkIcon from '~icons/knowz-iconify/social-apple-dark';
import AppleLightIcon from '~icons/knowz-iconify/social-apple-light';
import FacebookColorToneIcon from '~icons/knowz-iconify/social-facebook-color-tone';
import GithubDarkIcon from '~icons/knowz-iconify/social-github-dark';
import GithubLightIcon from '~icons/knowz-iconify/social-github-light';
import GoogleColorToneIcon from '~icons/knowz-iconify/social-google-color-tone';
import LinkedinColorToneIcon from '~icons/knowz-iconify/social-linkedin-color-tone';
import MicrosoftColorToneIcon from '~icons/knowz-iconify/social-microsoft-color-tone';
import PinterestColorToneIcon from '~icons/knowz-iconify/social-pinterest-color-tone';
import XDarkIcon from '~icons/knowz-iconify/social-x-dark';
import XLightIcon from '~icons/knowz-iconify/social-x-light';
import UserLoginIcon from '~icons/knowz-iconify/user-login';

type ServiceBrandingType = {
  order: number;
  icon: (theme: Theme, props: SVGProps<SVGSVGElement>) => React.ReactElement;
};

const serviceBranding: { [key: string]: ServiceBrandingType } = {
  google: {
    order: 1,
    icon: (_, props) => <GoogleColorToneIcon {...props} />,
  },

  gitHub: {
    order: 2,
    icon: (theme, props) =>
      theme.palette.mode === 'dark' ? (
        <GithubLightIcon {...props} />
      ) : (
        <GithubDarkIcon {...props} />
      ),
  },

  office365: {
    order: 3,
    icon: (_, props) => <MicrosoftColorToneIcon {...props} />,
  },

  linkedin: {
    order: 4,
    icon: (_, props) => <LinkedinColorToneIcon {...props} />,
  },

  apple: {
    order: 5,
    icon: (theme, props) =>
      theme.palette.mode === 'dark' ? (
        <AppleLightIcon {...props} />
      ) : (
        <AppleDarkIcon {...props} />
      ),
  },

  facebook: {
    order: 6,
    icon: (_, props) => <FacebookColorToneIcon {...props} />,
  },

  twitter: {
    order: 7,
    icon: (theme, props) =>
      theme.palette.mode === 'dark' ? (
        <XLightIcon {...props} />
      ) : (
        <XDarkIcon {...props} />
      ),
  },

  pinterest: {
    order: 8,
    icon: (_, props) => <PinterestColorToneIcon {...props} />,
  },

  slack: {
    order: 9,
    icon: (_, props) => <SlackColorToneIcon {...props} />,
  },

  custom: {
    order: 100,
    icon: (_, props) => <UserLoginIcon {...props} />,
  },
};

export default serviceBranding;
